import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { pickBy } from 'lodash';

import { dateFormat } from '../../../config';
import { amountFormater } from '../ManagePaymentListing/ColumnFormater';
import PaymentDetailsContainer from './PaymentDetailsContainer';
import PaymentDetailsTable from './PaymentDetailsTable';
import { formatSortCode, formatAccountToView } from '../../../utils/accountUtils';
import { formatLongDateTime } from '../../../utils/dateUtils';
import { chapsPaymentPropTypes } from '../../../states/managePayments/propTypes';

export const formatAmount = ({ value }) => amountFormater({ amount: value });

export const formatAccount = ({ name = '', account_number = '', sort_code = '' }) =>
	`${name} | ${formatSortCode(sort_code)} | ${account_number}`;

export const ChapsDetails = ({ mandate, content }) => {
	const {
		fromLabel,
		toLabel,
		feesLabel,
		typeLabel,
		createdByLabel,
		paymentDateLabel,
		createdOnLabel,
		amountLabel,
		refLabel,
	} = content;

	const {
		mandateType,
		created_by,
		created_timestamp,
		rawAmount,
		reference,
		charge,
		fromAccount = {},
		to_account: toAccount = {},
		submission_date,
	} = mandate;
	const tableRowMapping = pickBy({
		[typeLabel]: mandateType,
		[fromLabel]: formatAccountToView(fromAccount),
		[toLabel]: formatAccount(toAccount),
		[amountLabel]: formatAmount(rawAmount),
		[refLabel]: reference,
		[feesLabel]: formatAmount(charge),
		[paymentDateLabel]: moment(submission_date).format(dateFormat),
		[createdByLabel]: created_by,
		[createdOnLabel]: created_timestamp && formatLongDateTime(created_timestamp),
	});
	return <PaymentDetailsTable tableRowMapping={tableRowMapping} />;
};

export default PaymentDetailsContainer(ChapsDetails);

ChapsDetails.propTypes = {
	...chapsPaymentPropTypes,
	content: PropTypes.shape({}),
};
